import Vue from "vue";

const clickAway = {
  bind: (el, binding, vNode) => {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += ` Found in component '${compName}'`;
      }
      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const { bubble } = binding.modifiers;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };

    el.vueClickAway = handler;
    document.addEventListener("click", handler);
  },
  unbind: (el) => {
    document.removeEventListener("click", el.vueClickAway);
    el.vueClickAway = null;
  },
};

export default clickAway;

Vue.directive("click-away", clickAway);
